<template>
  <div class="aboutUs">
    <div class="about-image">
      <img src="@/assets/img/aboutUsTopImg.svg" alt="" width="100%">
    </div>
    <div class="about-content  center-wrapper">
      <div class="about-content-left">
        <h1 class="about-content-left-title">甄宝阁</h1>
        <div class='about-shuxian'></div>
        <h1 class="about-content-left-minTitle">ZB TESTING</h1>
        <div class="about-content-left-content">
          <p>
            甄宝阁是广州智立方信息科技有限公司（简称‘智立方”）开发的一款免费提供珠宝证书查询检测服务的软件系统 …
          </p>
          <p style="margin: 20px 0;">
            智立方创立于 2016 年，秉持“以科技为核心智创造智能世界”的理念，专注人工智能技术应用领域，以先进的生产技术为全国 50 ％的检测机构提供软硬件服务。公司主营产品： AI 机械研发、珠宝检侧业务系统、智能证书覆膜机、智能拍照系统、软件／网站定制。
          </p>
          <p>
            甄宝阁小程序作为智立方旗下的优秀产品，短短时间内快速成长，成为专门为消费者提供珠宝领域专家咨询、三方鉴定权威证书查询、知识分享的一站式服务平台；严选国家认可质检机构作为数据来源，杜绝虚假信息，为消费者保驾护航。
          </p>
        </div>
      </div>
      <div class="about-content-right">
        <img src="@/assets/img/aboutUsXzlImg.png" alt="" width="100%">
      </div>
    </div>
    <div class="about-youdian">
      <div class="about-youdian-content center-wrapper">
        <div>
          <img src="@/assets/img/aboutUsChina.gif" alt="" width="100%">
        </div>
        <div class="about-text">
          <p :class="`about-text-item about-text-item${index}`" v-for="(item, index) of textLists" :key="index">{{item}}</p>
        </div>
      </div>
    </div>
    <aboutUsFooter />
    <div class="about-footer">
      <div class="about-footer-content center-wrapper">
        <p>
          创造价值
        </p>
        <p>
          合作共<span style="letter-spacing: 0px;">赢</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import aboutUsFooter from '@/components/aboutUsFooter'
export default {
  components: {
    aboutUsFooter,
  },
  data () {
    return {
      zxywList1: ['珠宝检测站入驻','珠宝检测业务系统','珠宝快速质检系统','智能拍照系统'],
      zxywList2: ['检测证书覆膜机','软件网站小程序定制','Al 非标机械设计研发',],
      textLists: [
        '甄宝阁数据库证书存储量累计超过2亿条',
        '甄宝阁小程序日均证书查询量30000+',
        '甄宝阁小程序累计用户达50W+',
        '甄宝阁所属检测系统日均证书制作量200000+',
        '公司业务遍布全国省份16+，系统服务实验室150+',
      ]
    }
  }
}
</script>

<style lang='scss'>
.aboutUs {
  .about-content {
    padding: 40px 0;
    display: flex;
    .about-content-left {
      width: 45%;
      .about-content-left-title {
        font-size: 24px;
      }
      .about-shuxian{
        margin: 15px 0;
        background: rgb(32,147,202);
        height: 5px;
        width: 48px;
        border-radius: 0 4px 4px 0;
      }
      .about-content-left-minTitle {
        font-size: 60px;
        font-weight: 600;
        color: rgb(232,232,232)
      }
      .about-content-left-content {
        line-height: 30px;
        margin-top: 30px;
      }
    }
    .about-content-right {
      width: 55%;
    }
  }
  .about-youdian {
    background-image: url(~@/assets/img/aboutUsLocationBg.png);
    padding: 40px 0;
    .about-youdian-content {
      display: flex;
      justify-content: space-between;
      >div {
        width: 48%;
      }
    }
  }
  padding-bottom: 30px;
  .about-footer {
    color:rgb(42,151,203);
    border-top: 1px solid rgb(42,151,203);
    border-bottom: 1px solid rgb(42,151,203);
    padding: 10px 0;
    letter-spacing: 100px;
    font-size: 24px;
    .about-footer-content {
      display: flex;
      justify-content: space-around;
      p{
        text-align: center;
      }
    }
  }
  .about-text {
    position: relative;
    background: no-repeat center;
    background-image: url(~@/assets/img/aboutUsYoushi.png);
    background-size: 100%;
    .about-text-item0 {
      top: 14%;
      left: 13%;
    }
    .about-text-item1 {
      top: 31%;
      left: 13%;
    }
    .about-text-item2 {
      top: 48%;
      left: 29%;
    }
    .about-text-item3 {
      top: 64%;
      left: 5%;
    }
    .about-text-item4 {
      top: 80.5%;
      left: 14%;
    }
    .about-text-item {
      position: absolute;
      font-size: 20px;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>